import React from 'react';
import PropTypes from 'prop-types';
import { Container, Wrapper } from './styles';

export default function Modal({ children }) {
  return (
    <Container>
      <Wrapper>{children}</Wrapper>
    </Container>
  );
}

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.object])
    .isRequired,
};
